import React, { useEffect, useState } from "react";
import { 
    AiOutlineArrowLeft,
    AiOutlineSetting,
 } from "react-icons/ai";
import { 
    DefaultButton, 
 } from "@fluentui/react";
import './invoice.css';
import moment from "moment";

import Details from "./details-tabs/Details";
import Charges from "./details-tabs/Charges";
import StatementOfFacts from "./details-tabs/StatementOfFacts";

const DetailsPage = ({data, onBack, onSelect}:any) => {
    const [selectedTab, setSelectedTab] = useState(0);
    
    const formatName = (name:any) =>{
        let clean = (name).slice(12).replaceAll('.pdf','').replaceAll('_',' ').split(' ');
        for (var i = 0; i < clean.length; i++) {
            clean[i] = clean[i].charAt(0).toUpperCase() + clean[i].substring(1);     
        }
        return clean?.join(' ');
    }
    return (
        <div className="details-page">
            <div className="header">
                <div className="left">
                    <DefaultButton className="btn" onClick={onBack}><AiOutlineArrowLeft/></DefaultButton>
                    <h2 className="name">{data[1]===0?"Invoice Details":data[1]===1?"Billing Statement":formatName(data[0])}</h2>
                </div>
                <div className="right">
                    <DefaultButton className="btn"><AiOutlineSetting/></DefaultButton>
                </div>
            </div>
            <div className="details-card" style={{backgroundColor:data[1]===2?"#525252":"#FFF"}}>
                {data[1]!==2 && (
                <div className="details-header">
                    <div className="left-group">
                        {data[1]===0 && (
                            <div className="icon">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M15.9361 7.25191C12.2987 7.25192 8.73807 8.15064 6.54213 9.8643C6.51596 9.88473 6.49004 9.92555 6.49004 9.9882V21.6145C6.49004 21.6749 6.51434 21.7151 6.53948 21.7359C8.73308 23.5514 12.2963 24.5024 15.9361 24.5024C19.5759 24.5024 23.1391 23.5514 25.3327 21.7359C25.3579 21.7151 25.3822 21.6749 25.3822 21.6145V9.98818C25.3822 9.92553 25.3563 9.88471 25.3301 9.86428C23.1341 8.1506 19.5736 7.2519 15.9361 7.25191ZM15.9361 6.09525C19.7122 6.09523 23.5651 7.0197 26.0417 8.95243C26.3715 9.20984 26.5388 9.59922 26.5388 9.98818V21.6145C26.5388 21.9913 26.3819 22.369 26.0702 22.627C23.5931 24.6771 19.7263 25.659 15.9361 25.659C12.1459 25.659 8.2791 24.6771 5.80199 22.627C5.49031 22.369 5.33337 21.9913 5.33337 21.6145V9.9882C5.33337 9.59924 5.50068 9.20985 5.83053 8.95244C8.30715 7.01974 12.1601 6.09526 15.9361 6.09525Z" fill="#000" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M13.6228 6.26557C13.3034 6.26557 13.0445 6.5245 13.0445 6.8439V24.5794C13.0445 24.8988 13.3034 25.1577 13.6228 25.1577C13.9422 25.1577 14.2011 24.8988 14.2011 24.5794V6.8439C14.2011 6.5245 13.9422 6.26557 13.6228 6.26557ZM9.76727 7.02027C9.44786 7.02027 9.18894 7.2792 9.18894 7.5986V23.8247C9.18894 24.1441 9.44786 24.403 9.76727 24.403C10.0867 24.403 10.3456 24.1441 10.3456 23.8247V7.5986C10.3456 7.2792 10.0867 7.02027 9.76727 7.02027Z" fill="#000" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M14.2011 11.9111C14.2011 11.5917 13.9422 11.3328 13.6228 11.3328H9.76727C9.44786 11.3328 9.18894 11.5917 9.18894 11.9111C9.18894 12.2305 9.44786 12.4895 9.76727 12.4895H13.6228C13.9422 12.4895 14.2011 12.2305 14.2011 11.9111ZM14.2011 15.7116C14.2011 15.3922 13.9422 15.1333 13.6228 15.1333H9.76727C9.44786 15.1333 9.18894 15.3922 9.18894 15.7116C9.18894 16.031 9.44786 16.2899 9.76727 16.2899H13.6228C13.9422 16.2899 14.2011 16.031 14.2011 15.7116ZM14.2011 19.512C14.2011 19.1926 13.9422 18.9337 13.6228 18.9337H9.76727C9.44786 18.9337 9.18894 19.1926 9.18894 19.512C9.18894 19.8315 9.44786 20.0904 9.76727 20.0904H13.6228C13.9422 20.0904 14.2011 19.8315 14.2011 19.512Z" fill="#000" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M19.8037 19.0476C20.3984 19.049 20.9703 18.8577 21.3982 18.5144C21.826 18.1711 22.0761 17.7029 22.0953 17.209C22.0965 16.5812 21.2838 15.1813 20.6305 14.1577C20.1917 13.4702 19.8248 12.9524 19.8248 12.9524C19.8248 12.9524 19.454 13.4676 19.0101 14.1522C18.3482 15.1731 17.5239 16.5707 17.5239 17.1989C17.5399 17.6929 17.7869 18.1622 18.2126 18.5074C18.6382 18.8525 19.2089 19.0463 19.8037 19.0476ZM19.1017 17.5129C18.9716 17.4074 18.9168 17.2977 18.9003 17.2093L19.1017 17.5129ZM18.9003 17.2093C18.9054 17.189 18.9142 17.1571 18.9293 17.112C18.9696 16.9918 19.0356 16.8329 19.1296 16.6378C19.3085 16.267 19.5538 15.8371 19.8157 15.4104C20.0737 15.8375 20.3155 16.2679 20.4917 16.6392C20.5846 16.8349 20.6499 16.9945 20.6897 17.1156C20.7045 17.1607 20.7133 17.1928 20.7184 17.2135C20.7008 17.3018 20.645 17.4109 20.5146 17.5155C20.3513 17.6465 20.0993 17.7422 19.8069 17.7415C19.5144 17.7409 19.2634 17.6441 19.1017 17.5129" fill="#000" />
                                </svg>
                            </div>
                        )}
                    <div className="left">
                        <h3 className="name">{data[0]?.product ?? data[0]?.billTitle ?? '-'}</h3>
                        <p className="order-num">{data[0]?.nominationNo ?? data[0]?.billAccount ?? '-'}</p>
                    </div>
                    </div>
                    <div className="right">
                        {data[1]===0?(
                            <h3 className="value">${data[0]?.amount!==null||data[0]?.amount!==undefined ? (data[0]?.amount)?.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                }):'-'}</h3>
                        ):(
                            <h3 className="value">${data[0]?.billAmount!==null||data[0]?.billAmount!==undefined ? (data[0]?.billAmount)?.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                }):'-'}</h3>
                        )}
                        {data[1]===0?(
                            <p className="due">Issued: {data[0]?.issuedDate ? moment(data[0]?.issuedDate).format('MMM DD, YYYY'):'-'}</p>
                        ):(
                            <p className="due">{data[1]===1?"Billing Period":"Date"}: {data[0]?.billPeriod ? data[0]?.billPeriod : moment(data[0]?.issuedDate).format('MMM DD, YYYY')}</p>
                        )}
                    </div>
                </div>
                )}
                <div className="details-tabs" style={{display:data[1]===2?"none":"flex"}}>
                    {data[1]===0 ? (
                        <>
                            <DefaultButton className={selectedTab===0?"active-tab":"tab"} onClick={()=>setSelectedTab(0)}>Details</DefaultButton>
                            <DefaultButton className={selectedTab===1?"active-tab":"tab"} onClick={()=>setSelectedTab(1)}>Summary of Charges</DefaultButton>
                            <DefaultButton className={selectedTab===2?"active-tab":"tab"} onClick={()=>setSelectedTab(2)}>Statement of Facts</DefaultButton>
                        </>
                    ):data[1]===1 ? (
                        <>
                            <DefaultButton className={selectedTab===0?"active-tab":"tab"} onClick={()=>setSelectedTab(0)}>Details</DefaultButton>
                            <DefaultButton className={selectedTab===1?"active-tab":"tab"} onClick={()=>setSelectedTab(3)}>Invoices</DefaultButton>
                        </>
                    ):(<></>)}
                </div>
                {selectedTab===0 && (
                    <Details data={data[0]} type={data[1]}/>
                )}
                {(selectedTab===1 || selectedTab===3) && (
                    <Charges data={data[0]} type={data[1]} onSelect={onSelect}/>
                )}
                {selectedTab===2 && (
                    <StatementOfFacts  data={data[0].activities} type={data[1]}/>
                )}
            </div>
        </div>
    )
}

export default DetailsPage;